import Layout from "@/views/layout/index";

const newsCenter = [
  // {
  //   path: "/newsCenter",
  //   name: "NewsCenter",
  //   component: Layout,
  //   // hidden: true,
  //   isChildren: false,
  //   mCode: "XWZX",
  //   meta: { title: '资讯中心', icon: 'dashboard' },
  //   children: [
  //     {
  //       path: '/newsCenter',
  //       component: () => import('@/views/newsCenter/index'),
  //     }
  //   ]
  // },

  {
    path: "/newDetail",
    name: "NewDetail",
    hidden: true,
    component: Layout,
    isChildren: false,
    meta: { title: '资讯详情', icon: 'el-icon-s-help' },
    children: [
      {
        path: '/newDetail',
        component: () => import('@/views/newsCenter/detail'),
      }
    ]
  }
]

export default newsCenter



// WEBPACK FOOTER //
// ./src/router/newsCenter/index.js